import { render, staticRenderFns } from "./PopupRouterViewDetail.vue?vue&type=template&id=867ce0f4&"
import script from "./PopupRouterViewDetail.vue?vue&type=script&lang=js&"
export * from "./PopupRouterViewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports